// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","main":"_9lhYt","brandValue":"_1jHJ1"};